import { FC } from "react";
import { cn } from "../utils/class-names";

export const TelegramIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("h-6 w-6", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="currentColor"
    />
    <path
      d="M14.9904 5.86343C15.0794 5.28809 14.5324 4.83396 14.0209 5.05857L3.83203 9.532C3.46518 9.69307 3.49201 10.2488 3.87249 10.3699L5.97365 11.0391C6.37473 11.1668 6.80894 11.1007 7.15915 10.8588L11.8964 7.58593C12.0393 7.48721 12.195 7.69036 12.0729 7.81614L8.66294 11.3319C8.33215 11.6729 8.3978 12.2509 8.79573 12.5004L12.6136 14.8945C13.0418 15.163 13.5927 14.8933 13.6727 14.3758L14.9904 5.86343Z"
      fill="#0E0F10"
    />
  </svg>
);
